export const settings = {
  // Language & Region Section
  'settings.preferredLanguage': 'Preferred Language',
  'settings.languageRegion.title': 'Language & Region',
  'settings.languageRegion.description': 'Set your preferred language and regional settings',
  'settings.languageRegion.livePreview': 'Live Preview',
  'settings.languageRegion.interfaceLanguage': 'Interface language for menus, buttons, and system messages',
  'settings.languageRegion.autoDetectionNote': '💡 Language is automatically set based on your country selection, but you can change it here.',
  'settings.languageRegion.currencyDisplay': 'Currency Display',
  'settings.languageRegion.currencyDescription': 'Currency used to display funding amounts',
  'settings.languageRegion.dateFormat': 'Date Format',
  'settings.languageRegion.dateDescription': 'Date display format used throughout the interface',
  'settings.languageRegion.regionalInfo': 'Regional Information',
  'settings.languageRegion.languageAffects': '• Language affects all user interface text',
  'settings.languageRegion.currencyAffects': '• Currency settings change how amounts are displayed',
  'settings.languageRegion.dateAffects': '• Date formats are used in calendars and lists',
  'settings.languageRegion.changesImmediate': '• Changes take effect immediately',

  // Profile Information Section
  'settings.profile.title': 'Profile Information',
  'settings.profile.description': 'Manage your account information and profile photo',
  'settings.profile.photo': 'Profile Photo',
  'settings.profile.uploadPhoto': 'Upload a photo to personalize your account (max 5MB, JPG/PNG/WebP)',
  'settings.profile.firstName': 'First Name',
  'settings.profile.lastName': 'Last Name',
  'settings.profile.jobTitle': 'Job Title',
  'settings.profile.jobTitlePlaceholder': 'e.g. Business Development Manager',
  'settings.profile.email': 'Email Address',
  'settings.profile.emailNote': 'Contact support to change your email address',
  'settings.profile.editProfile': 'Edit Profile',
  'settings.profile.changePassword': 'Change Password',
  'settings.profile.connectedAccounts': 'Connected Accounts',
  'settings.profile.connected': 'Connected',
  'settings.profile.notConnected': 'Not connected',
  'settings.profile.disconnect': 'Disconnect',
  'settings.profile.connect': 'Connect',
  'settings.profile.accountsNote': 'Connecting additional accounts enables single sign-on and helps sync your professional profile information.',

  // Notifications Section
  'settings.notifications.title': 'Notifications',
  'settings.notifications.description': 'Control how and when you receive notifications from subvention360',
  'settings.notifications.fundingMatches': 'Funding Matches',
  'settings.notifications.fundingMatchesDesc': 'New grants that match your profile and interests',
  'settings.notifications.platformUpdates': 'Platform Updates',
  'settings.notifications.platformUpdatesDesc': 'New features, improvements, and system announcements',
  'settings.notifications.tipsAndPractices': 'Tips & Best Practices',
  'settings.notifications.tipsAndPracticesDesc': 'Helpful guides and expert advice for successful applications',
  'settings.notifications.highPriority': 'high priority',
  'settings.notifications.mediumPriority': 'medium priority',
  'settings.notifications.lowPriority': 'low priority',
  'settings.notifications.email': 'Email',
  'settings.notifications.enableEmail': 'Enable email notifications',
  'settings.notifications.inApp': 'In Browser',
  'settings.notifications.enableInApp': 'Enable browser notifications',
  'settings.notifications.frequency': 'Frequency',
  'settings.notifications.immediate': 'Immediate',
  'settings.notifications.dailyDigest': 'Daily Digest',
  'settings.notifications.weeklyDigest': 'Weekly Digest',
  'settings.notifications.disabled': 'Disabled',
  'settings.notifications.timing': 'Notification Timing',
  'settings.notifications.timingImmediate': '• Immediate: Sent as soon as the event occurs',
  'settings.notifications.timingDaily': '• Daily Digest: Grouped summary sent once per day (9:00 AM)',
  'settings.notifications.timingWeekly': '• Weekly Digest: Weekly summary sent on Mondays (9:00 AM)',
  'settings.notifications.timingDisabled': '• Disabled: No notifications for this type',
  'settings.notifications.recommended': '💡 Recommended Settings',
  'settings.notifications.recommendedFunding': '• Funding Matches: Immediate Email and Browser notifications (don\'t miss opportunities!)',
  'settings.notifications.recommendedPlatform': '• Platform Updates: Weekly digest to stay informed without overwhelm',
  'settings.notifications.recommendedTips': '• Tips & Best Practices: Weekly digest to learn at your own pace',

  // Theme & UI Section
  'settings.theme.title': 'Theme & Interface',
  'settings.theme.description': 'Customize the appearance and layout of your interface',
  'settings.theme.livePreview': 'Live Preview Mode',
  'settings.theme.enablePreview': 'Enable Preview',
  'settings.theme.theme': 'Theme',
  'settings.theme.light': 'Light',
  'settings.theme.lightDesc': 'Clean and bright interface',
  'settings.theme.dark': 'Dark',
  'settings.theme.darkDesc': 'Easy on the eyes in low light',
  'settings.theme.system': 'System',
  'settings.theme.systemDesc': 'Follows your device setting',
  'settings.theme.fontSize': 'Font Size',
  'settings.theme.fontSizeStandard': 'Standard readable size',
  'settings.theme.dashboardDensity': 'Dashboard Density',
  'settings.theme.spacious': 'Spacious',
  'settings.theme.spaciousDesc': 'More breathing room and padding',
  'settings.theme.previewSample': 'Preview Sample',
  'settings.theme.sampleCard': 'Sample Dashboard Card',
  'settings.theme.sampleDesc': 'This is how your interface will look with the selected settings.',
  'settings.theme.customizationTips': 'Customization Tips',
  'settings.theme.tip1': '• Use Preview Mode to test changes before applying them',
  'settings.theme.tip2': '• System theme automatically switches based on your device',
  'settings.theme.tip3': '• Compact density is great for large screens and power users',
  'settings.theme.tip4': '• All changes are saved automatically and synced across your devices',

  // Privacy & Security Section
  'settings.privacy.title': 'Privacy & Security',
  'settings.privacy.description': 'Manage your security settings, active sessions, and data privacy',
  'settings.privacy.twoFactor': 'Two-Factor Authentication',
  'settings.privacy.authenticatorApp': 'Authenticator App',
  'settings.privacy.twoFactorDesc': 'Add an extra layer of security with TOTP authentication',
  'settings.privacy.setUp2FA': 'Set Up 2FA',
  'settings.privacy.activeSessions': 'Active Sessions',
  'settings.privacy.currentSession': 'Current',
  'settings.privacy.revoke': 'Revoke',
  'settings.privacy.inactive': 'Inactive',
  'settings.privacy.exportData': 'Export Your Data',
  'settings.privacy.exportDesc': 'Download a complete copy of your personal data stored in subvention360. This includes your profile, preferences, and activity history.',
  'settings.privacy.completeData': 'Complete Data (JSON)',
  'settings.privacy.completeDataDesc': 'Full structured export with all metadata - ideal for backup',
  'settings.privacy.downloadJSON': 'Download JSON',
  'settings.privacy.spreadsheetFormat': 'Spreadsheet Format (CSV)',
  'settings.privacy.spreadsheetDesc': 'Tabular format for analysis in Excel or Google Sheets',
  'settings.privacy.downloadCSV': 'Download CSV',
  'settings.privacy.deleteAccount': 'Delete Account',
  'settings.privacy.deleteWarning': 'Account deletion is permanent and cannot be undone. All your data will be permanently removed.',
  'settings.privacy.deleteMyAccount': 'Delete My Account',
  'settings.privacy.unknownIP': 'Unknown IP',
  'settings.privacy.justNow': 'Just now',
  'settings.privacy.hoursAgo': '{hours} hours ago',
  'settings.privacy.changeEmail': 'Change your email address',
  'settings.privacy.emailConfirmation': 'A confirmation email will be sent to your new address',
  'settings.privacy.currentEmail': 'Current email',
  'settings.privacy.newEmail': 'New email address',
  'settings.privacy.changeEmailButton': 'Change Email',

  // Personal Settings Main
  'settings.personal.title': 'Personal Settings',
  'settings.personal.description': 'Manage your account information, preferences, and privacy settings',

  // Settings Page Main
  'settings.title': 'Settings',
  'settings.description': 'Manage your account information, preferences, and privacy settings',
  'settings.tabs.personal': 'Personal Settings',
  'settings.tabs.organization': 'Organization',
  'settings.tabs.team': 'Team',
  'settings.tabs.suspended': 'Suspended Accounts',
  'settings.tabs.dashboards': 'Advanced Dashboards',
  'settings.tabs.admin': 'Admin Features',
  'settings.dashboards.title': 'Advanced Dashboards',
  'settings.dashboards.description': 'Access specialized dashboards based on your role and permissions',
  'settings.admin.title': 'Admin Features',
  'settings.admin.description': 'Administrative tools for system management and monitoring',
  'settings.admin.roleRequired': 'Admin Role Required',
  'settings.admin.switchRole': 'Switch to Admin role using the role selector to access these features.',

  // Suspended Accounts
  'settings.suspended.title': 'Suspended Accounts',
  'settings.suspended.description': 'Manage your suspended profiles. Suspended profiles are hidden from your dashboard and excluded from billing.',
  'settings.suspended.noSuspended': 'No suspended accounts',
  'settings.suspended.noSuspendedDesc': 'You don\'t have any suspended profiles. Suspended profiles can be restored at any time.',
  'settings.suspended.suspendedOn': 'Suspended on',
  'settings.suspended.restoreProfile': 'Restore Profile',
  'settings.suspended.deletePermanently': 'Delete Permanently',
  'settings.suspended.confirmRestore': 'Are you sure you want to restore this profile?',
  'settings.suspended.confirmDelete': 'Are you sure you want to permanently delete this profile? This action cannot be undone.',
  'settings.suspended.restoring': 'Restoring...',
  'settings.suspended.deleting': 'Deleting...',

  // Language Feature Info Section
  'settings.languageFeature.title': 'Automatic Language Detection',
  'settings.languageFeature.description': 'subvention360 automatically sets your interface language based on your selected country',
  'settings.languageFeature.howItWorks': 'How Automatic Language Detection Works',
  'settings.languageFeature.step1': 'When you select a country during profile setup, we automatically set the interface language',
  'settings.languageFeature.step2': 'You can manually override the language at any time in Settings',
  'settings.languageFeature.step3': 'Your manual language choice is always preserved',
  'settings.languageFeature.supportedCountries': 'Countries with Automatic Language Detection',
  'settings.languageFeature.englishCountries': 'Countries Using English by Default',
  'settings.languageFeature.coverageTitle': 'Complete Translation Coverage',
  'settings.languageFeature.coverageDescription': 'All interface elements, navigation, forms, and user-facing content have been fully translated into the supported languages (except subsidies content which varies by source).',

  // Subscription Management - Pause Feature
  'settings.subscription.pauseMembership.title': 'Pause Membership',
  'settings.subscription.pauseMembership.description': 'Temporarily suspend your subscription',
  'settings.subscription.pauseMembership.info': 'You can pause your subscription at any time. You will retain access until the end of your current billing period.',
  'settings.subscription.pauseMembership.button': 'Pause Subscription',
  'settings.subscription.pauseMembership.currentlyPaused': 'Subscription Currently Paused',
  'settings.subscription.pauseMembership.pausedUntil': 'Access until {date}',
  'settings.subscription.pauseMembership.resumeButton': 'Resume Subscription',

  // Pause Dialog
  'settings.subscription.pauseDialog.title': 'Pause your subscription?',
  'settings.subscription.pauseDialog.description': 'Your subscription will be suspended after your current billing period ends. No payments will be charged while paused.',
  'settings.subscription.pauseDialog.accessUntil': 'Access until:',
  'settings.subscription.pauseDialog.whatHappens': 'What will happen:',
  'settings.subscription.pauseDialog.point1': 'You keep full access until the end of your billing period',
  'settings.subscription.pauseDialog.point2': 'No payments will be charged after this date',
  'settings.subscription.pauseDialog.point3': 'You can resume your subscription anytime',
  'settings.subscription.pauseDialog.resumeAnytime': 'You can resume your subscription anytime via the billing portal.',
  'settings.subscription.pauseDialog.confirm': 'Confirm Pause',
  'settings.subscription.pauseDialog.pausing': 'Pausing...',
  'settings.subscription.pauseDialog.successTitle': 'Subscription Paused',
  'settings.subscription.pauseDialog.successDescription': 'Your subscription is now paused. Access until {date}',
  'settings.subscription.pauseDialog.errorTitle': 'Pause Error',
  'settings.subscription.pauseDialog.errorDescription': 'Unable to pause subscription. Please try again.',

  // Paused State Blocker
  'subscription.paused.title': 'Subscription Paused',
  'subscription.paused.description': 'Your subscription is currently paused. To continue using the platform, please resume your subscription.',
  'subscription.paused.accessEnded': 'Access ended on:',
  'subscription.paused.pausedSince': 'Paused since {date}',
  'subscription.paused.resumeInstructions': 'To resume your subscription and regain access to the platform, click the button below.',
  'subscription.paused.resumeButton': 'Resume Subscription',
  'subscription.paused.redirecting': 'Redirecting...',
  'subscription.paused.helpText': 'You will be redirected to the Stripe billing portal to manage your subscription.',
  'subscription.paused.needHelp': 'Need help?',
  'subscription.paused.redirectError': 'Redirect Error',
  'subscription.paused.redirectErrorDescription': 'Unable to open billing portal. Please try again.',

  // Payment Failed Blocker
  'subscription.paymentFailed.title': 'Payment Failed',
  'subscription.paymentFailed.accessExpired': 'Your grace period has expired. Please update your payment method to continue using the platform.',
  'subscription.paymentFailed.gracePeriodActive': 'Your subscription payment failed. You retain access during the grace period.',
  'subscription.paymentFailed.failedOn': 'Payment failed on:',
  'subscription.paymentFailed.gracePeriodRemaining': 'You have {days} day(s) remaining to update your payment method before losing access.',
  'subscription.paymentFailed.gracePeriodExpiredMessage': 'Your 10-day grace period has expired. Platform access is suspended.',
  'subscription.paymentFailed.whatToDo': 'What to do now:',
  'subscription.paymentFailed.step1': 'Click "Update Payment Method" below',
  'subscription.paymentFailed.step2': 'Add or update your payment method in the Stripe portal',
  'subscription.paymentFailed.step3': 'Access will be restored immediately after updating',
  'subscription.paymentFailed.updatePaymentButton': 'Update Payment Method',
  'subscription.paymentFailed.redirecting': 'Redirecting...',
  'subscription.paymentFailed.redirectError': 'Redirect Error',
  'subscription.paymentFailed.billingPortalNote': 'You will be redirected to the secure Stripe billing portal.',

  // Settings Placeholders
  'settings.placeholders.enterNewPassword': 'Enter new password',
  'settings.placeholders.confirmNewPassword': 'Confirm new password',
  'settings.placeholders.newEmailAddress': 'new@email.com',
  'settings.placeholders.deleteAccountConfirmation': 'DELETE MY ACCOUNT',
  'settings.placeholders.expertDisplayName': 'e.g. Expert Consulting Firm',
  'settings.placeholders.expertBio': 'Describe your expertise and services...',
  'settings.placeholders.billingEmail': 'billing@company.com',

  // Additional translations for UI elements
  'settings.preview.today': 'Today',
  'settings.preview.sampleFunding': 'Sample funding',
  'settings.theme.light.description': 'Clean and bright interface',
  'settings.theme.dark.description': 'Easy on the eyes in low light',
  'settings.theme.system.description': 'Follows your device setting',
  'settings.fontSize.small': 'Small',
  'settings.fontSize.small.description': 'Compact text for more content',
  'settings.fontSize.medium': 'Medium',
  'settings.fontSize.medium.description': 'Standard readable size',
  'settings.fontSize.large': 'Large',
  'settings.fontSize.large.description': 'Larger text for better readability',
  'settings.density.compact': 'Compact',
  'settings.density.compact.description': 'More information in less space',
  'settings.density.spacious.description': 'More breathing room and padding',

  // Role Settings Section (Type de profil)
  'settings.role.title': 'Profile Type',
  'settings.role.description': 'Select how you use subvention360',
  'settings.role.help.consultant': 'Manage multiple client profiles and provide grant consulting services',
  'settings.role.help.business_owner': 'Find funding for your own business',
  'settings.role.help.team_member': 'Access profiles shared by your organization',
  'settings.role.current': 'current',
  'settings.role.save': 'Save Changes',
  'settings.role.confirm_message': 'Are you sure you want to change your role? This will change your interface and permissions. The page will reload.',
  'settings.role.alert_title': 'Role Change:',
  'settings.role.alert_message': 'Your interface and permissions will be modified. The page will reload automatically.',
  'settings.role.toast.success_title': 'Role Updated',
  'settings.role.toast.success_description': 'Your role has been changed to {role}. Redirecting...',
  'settings.role.toast.error_title': 'Update Failed',
  'settings.role.toast.error_description': 'Unable to update your role. Please try again.',

  // Organization Settings Section
  'settings.organization.details.title': 'Organization Details',
  'settings.organization.details.description': 'Manage your organization name and basic information',
  'settings.organization.name.label': 'Organization Name',
  'settings.organization.name.placeholder': 'My Company',
  'settings.organization.name.help': 'This name is displayed to all team members',
  'settings.organization.logo.title': 'Organization Logo',
  'settings.organization.logo.description': 'Upload your organization logo to personalize your dashboard',
  'settings.organization.logo.upload': 'Upload Logo',
  'settings.organization.logo.change': 'Change Logo',
  'settings.organization.logo.uploading': 'Uploading...',
  'settings.organization.logo.formats': '• Formats: JPG, PNG, SVG or WebP',
  'settings.organization.logo.size': '• Maximum size: 2MB',
  'settings.organization.logo.recommended': '• Recommended: Square image (512x512px or larger)',
  'settings.organization.visibility.title': 'Team Visibility',
  'settings.organization.visibility.description': 'Control who can see team member list',
  'settings.organization.visibility.label': 'Who can see team members?',
  'settings.organization.visibility.all': 'All team members',
  'settings.organization.visibility.admins': 'Admins only',
  'settings.organization.visibility.help.all': 'All team members can see each other\'s names and emails',
  'settings.organization.visibility.help.admins': 'Only admins can see the full member list',
  'settings.organization.email.title': 'Email Restrictions',
  'settings.organization.email.description': 'Control which email domains can be invited to your organization',
  'settings.organization.email.domain.label': 'Restrict invitations to email domain',
  'settings.organization.email.domain.placeholder': '@yourcompany.com',
  'settings.organization.email.domain.help': 'Leave empty to allow any email domain. Example: @ecoemit.com',
  'settings.organization.email.external.label': 'Allow external invitations',
  'settings.organization.email.external.description': 'Allow inviting users outside the domain restriction',
  'settings.organization.save': 'Save Changes',
  'settings.organization.saving': 'Saving...',
  'settings.organization.unsaved': 'You have unsaved changes',
  'settings.organization.notMember': 'You are not a member of any organization.',

  // Team Settings Section
  'settings.team.title': 'Team Members',
  'settings.team.description': 'Manage who has access to your organization',
  'settings.team.invite': 'Invite Member',
  'settings.team.members.title': 'Active Members',
  'settings.team.members.count': '{count} member(s)',
  'settings.team.members.you': 'You',
  'settings.team.members.admin': 'Admin',
  'settings.team.members.member': 'Member',
  'settings.team.members.viewer': 'Viewer',
  'settings.team.members.customRole': 'Custom Role',
  'settings.team.members.edit': 'Edit',
  'settings.team.members.remove': 'Remove',
  'settings.team.members.viewPermissions': 'View Permissions',
  'settings.team.members.editPermissions': 'Edit Permissions',
  'settings.team.members.joined': 'Joined {date}',
  'settings.team.invitations.title': 'Pending Invitations',
  'settings.team.invitations.count': '{count} invitation(s)',
  'settings.team.invitations.sent': 'Sent {date}',
  'settings.team.invitations.expires': 'Expires {date}',
  'settings.team.invitations.resend': 'Resend',
  'settings.team.invitations.revoke': 'Revoke',
  'settings.team.invitations.none': 'No pending invitations',
  'settings.team.delete.title': 'Remove Member',
  'settings.team.delete.description': 'Are you sure you want to remove {name} from your organization? This action cannot be undone.',
  'settings.team.delete.confirm': 'Remove Member',
  'settings.team.delete.cancel': 'Cancel',
  'settings.team.delete.removing': 'Removing...',
  'settings.team.toast.removed': 'Team member removed successfully',
  'settings.team.toast.removeFailed': 'Failed to remove member',
  'settings.team.toast.cannotRemoveSelf': 'Cannot remove yourself',
  'settings.team.toast.cannotRemoveSelfDesc': 'You are the only admin. Promote another member to admin first.',
  'settings.team.toast.inviteRevoked': 'Invitation revoked',
  'settings.team.toast.inviteResent': 'Invitation resent',
  'settings.team.toast.inviteRevokeFailed': 'Failed to revoke invitation',
  'settings.team.toast.inviteResendFailed': 'Failed to resend invitation',
  'settings.team.toast.loadFailed': 'Failed to load team members',
  'settings.team.notMember': 'You are not a member of any organization.',
  'settings.team.activeMembers.title': 'Active Members',
  'settings.team.activeMembers.description': 'Team members who have accepted their invitations',
  'settings.team.invitations.description': 'Invitations sent but not yet accepted',
  'settings.team.members.youBadge': 'You',
} as const;